// extracted by mini-css-extract-plugin
module.exports = {"icon":"Collapser_icon__X8Xzd"};